<div class="fs-2" mat-dialog-title>
    Régularisation de votre abonnement
</div>
<div mat-dialog-content>
    <ng-container *ngIf="step == 1">
        <p class="mb-4">Vos accès ont été suspendus suite à un échec de paiement
            <ng-container *ngIf="amount > 0"> d’un montant de {{amount}}€</ng-container>
            .<br/>
            Vous pouvez relancer un paiement pour rétablir vos accès.
        </p>
        <div class="col-12 mb-4">
            <div class="icon-wrap">
                <i class="icon icon-card bg-primary"></i>
            </div>
            <b class="title-pm">
                Votre moyen de paiement enregistré :
            </b>
        </div>
        <div class="col-12">
            <div class="infoCb mb-4">
                <a (click)="onYesClick()" class="btn btn-lg btn-outline float-right">
                    <ng-container>Modifier</ng-container>
                </a>

                <b class="fs-4" *ngIf="user.payment_method.type == 'sepa_debit'">
                    Prélèvement bancaire<br/>
                </b>
                <b class="fs-4" *ngIf="user.payment_method.type == 'card'">
                    {{ user.payment_method.type_detail | titlecase }} {{ user.payment_method.last_4 }}
                    <br/>
                    Expire en {{ user.payment_method.exp_month }}/{{user.payment_method.exp_year}}
                </b>
            </div>
        </div>
        <p>Veuillez vérifier votre moyen de paiement et relancer le paiement pour débloquer votre compte</p>
    </ng-container>
    <ng-container *ngIf="step == 2">
        <ng-container *ngIf="status === null">
            <b>Une nouvelle tentative de paiement est en cours.</b>
            <br/>
            <p class="text-center mt-4 mb-4">
                <mat-spinner diameter="150" color="second" class="me-auto ms-auto"></mat-spinner>
            </p>
            <p class="mb-0">Cette opération peut prendre plusieurs secondes en fonction de votre établissement
                bancaire</p>
        </ng-container>
        <ng-container *ngIf="status === false">
            <ng-container *ngIf="reason !== 'pending_payment'">
                <b>Une erreur est survenue lors de votre paiement. Votre abonnement n’a pas été validé.</b>
                <br/>
                <p class="text-center mt-4 mb-4">
                    <img src="assets/error.png">
                </p>
                <p class="mb-0">Vous pouvez modifier votre moyen de paiement et relancer une nouvelle tentative pour pouvoir
                    accéder à LyBox</p>
            </ng-container>
            <ng-container *ngIf="reason === 'pending_payment'">
                <b>Une tentative de paiement est en cours sur votre facture. Cela peut prendre jusqu'a 4 jours pour les paiements par prélèvement bancaire</b>
                <p class="text-center mt-4 mb-4">
                    <img src="assets/error.png">
                </p>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="status === true">
            <b>Votre paiement est validée.</b>
            <br/>
            <p class="text-center mt-4 mb-4">
                <img src="assets/checked.png">
            </p>
            <p class="mb-0">Vous avez dés maintenant accès à toutes les fonctionnalités de votre forfait !</p>
        </ng-container>
    </ng-container>
</div>
<div mat-dialog-actions *ngIf="status !== null || step === 1">
    <button *ngIf="step === 1" type="button" (click)="onNoClick()" class="btn btn-outline">
        Annuler
    </button>
    <button *ngIf="step === 1" type="button" (click)="retryPaiment()" class="btn btn-primary">
        Relancer le paiement
    </button>
    <button *ngIf="step === 2 && status === false && reason !== 'pending_payment'" type="button" (click)="reInit()" class="btn btn-outline">
        Retour
    </button>
    <button *ngIf="step === 2 && status === false && reason !== 'pending_payment'" type="button" (click)="onYesClick()" class="btn btn-primary">
        Modifier mon moyen de paiement
    </button>
    <button *ngIf="step === 2 && status === true || (status === false && reason === 'pending_payment')" type="button" (click)="onNoClick()" class="btn btn-outline w-100">
        Fermer
    </button>
</div>
